import type { ComponentProps, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

const Label: FC<ComponentProps<'label'>> = ({ className, ...props }): ReactNode => {
    return (
        <label
            data-slot='label'
            className={cn('inline-flex items-center gap-2 text-sm font-medium text-foreground', className)}
            {...props}
        />
    )
}

export { Label }
